import { Skeleton } from "@/components/ui/skeleton"

export function SettingsFormSkeleton() {
  return (
    <div className="rounded-xl border shadow-sm">
      <div className="p-6 space-y-1.5 border-b">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-4 w-56" />
      </div>
      <div className="p-6 space-y-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-36" />
          <Skeleton className="h-9 w-full" />
        </div>
        <div className="flex justify-end">
          <Skeleton className="h-9 w-20" />
        </div>
      </div>
    </div>
  )
}
